import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import clsx from 'clsx';
import {
  FiRadio, FiCpu, FiZap, FiLayout, FiTag, FiShield, FiUsers, FiMail, FiBookOpen, FiMessageCircle, FiActivity, FiAward, FiPercent,
} from 'react-icons/fi';
import {
  MdOutlineHearing, MdOutlinePsychology, MdOutlinePayments, MdOutlineBolt, MdOutlineHub, MdOutlineVerifiedUser, MdOutlineHandshake, MdOutlinePersonRemove,
  MdOutlineAddShoppingCart, MdOutlineCampaign, MdOutlineBuild, MdOutlineAccountBalance, MdOutlineShield, MdOutlineFlight, MdOutlineStorefront, MdOutlineCellTower,
  MdOutlineQueryStats, MdOutlineConfirmationNumber, MdOutlineNotificationsActive,
  MdOutlineConstruction, MdOutlineCable, MdOutlineWorkspacePremium, MdOutlineApartment, MdOutlineCalculate,
  MdOutlineSchool, MdOutlineHelpOutline, MdOutlineGroups, MdOutlineWorkOutline,
} from 'react-icons/md';
import isActiveLink, { rememberSection } from '../isActiveLink';
import css from './css.module.scss';

export const icons = {
  recCalculator: MdOutlineCalculate,
  recAcademy: MdOutlineSchool,
  recSecurity: MdOutlineVerifiedUser,
  help: MdOutlineHelpOutline,
  aboutUs: MdOutlineGroups,
  jobs: MdOutlineWorkOutline,
  partners: MdOutlineHandshake,
  case: MdOutlineWorkspacePremium,
  allClients: MdOutlineApartment,
  agListen: MdOutlineHearing,
  agAnalysis: MdOutlineQueryStats,
  agCases: MdOutlineConfirmationNumber,
  agAlerts: MdOutlineNotificationsActive,
  agCustom: MdOutlineConstruction,
  agConnect: MdOutlineCable,
  listen: MdOutlineHearing,
  understand: MdOutlinePsychology,
  impact: MdOutlinePayments,
  actStep: MdOutlineBolt,
  sources: MdOutlineHub,
  securityPlat: MdOutlineVerifiedUser,
  howWeWork: MdOutlineHandshake,
  solRetention: MdOutlinePersonRemove,
  solCrossSell: MdOutlineAddShoppingCart,
  solRecommendation: MdOutlineCampaign,
  solEfficiency: MdOutlineBuild,
  solDecisions: MdOutlineAccountBalance,
  indBanking: MdOutlineAccountBalance,
  indInsurance: MdOutlineShield,
  indAirlines: MdOutlineFlight,
  indRetail: MdOutlineStorefront,
  indTelco: MdOutlineCellTower,
  collect: FiRadio,
  process: FiCpu,
  act: FiZap,
  overview: FiLayout,
  pricing: FiTag,
  security: FiShield,
  about: FiUsers,
  contact: FiMail,
  academy: FiBookOpen,
  agents: FiMessageCircle,
  status: FiActivity,
  cases: FiAward,
  calculator: FiPercent,
};

const MegaMenu = ({
  item, open, onNavigate, activeSection,
}) => {
  const location = useLocation();
  return (
  <div className={clsx(css.megaMenu, open && css.megaMenuOpen)} aria-hidden={!open}>
    {item && (
      <div className={css.megaInner} key={item.key}>
        {item.menu.map((column) => (
          <div key={column.title} className={clsx(css.megaColumn, column.wide && css.megaColumnWide, column.grid && css.megaColumnGrid)}>
            <p className={css.megaTitle}>{column.title}</p>
            <ul className={css.megaLinks}>
              {column.links.map((link) => {
                if (link.skeleton) {
                  return (
                    <li key={link.key} className={css.megaSkeleton} aria-hidden>
                      <span className={css.megaSkeletonIcon} />
                      <span className={css.megaSkeletonText} />
                    </li>
                  );
                }
                const Icon = icons[link.icon];
                return (
                  <li key={link.key}>
                    <HashLink smooth to={link.path} className={clsx(css.megaLink, !link.desc && css.megaLinkSingle, item.key === activeSection && !link.noActive && isActiveLink(link.path, location) && css.megaLinkActive)}
                      onClick={() => {
                        rememberSection(item.key, link.path);
                        onNavigate();
                      }} tabIndex={open ? 0 : -1}>
                      <span className={css.megaIcon}>{Icon && <Icon />}</span>
                      <span>
                        <span className={css.megaLinkTitle}>{link.title}</span>
                        {link.desc && <span className={css.megaLinkDesc}>{link.desc}</span>}
                      </span>
                    </HashLink>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    )}
  </div>
  );
};

MegaMenu.defaultProps = {
  item: null,
  open: false,
  onNavigate: () => { },
  activeSection: null,
};

MegaMenu.propTypes = {
  item: PropTypes.object,
  open: PropTypes.bool,
  onNavigate: PropTypes.func,
  activeSection: PropTypes.string,
};

export default MegaMenu;
